import { datadogRum } from '@datadog/browser-rum';
import axios from 'axios';

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Report errors with unknown status, including CORS errors
    if (!error.response?.status) {
      const errorContext = {
        url: error.config?.url,
        method: error.config?.method,
      };

      datadogRum.addError({ ...error, message: 'Unknown fetch error' }, errorContext);
    }

    return Promise.reject(error);
  },
);
